
export const MOBILE_BREAKPOINT = 768;

export const BREAKPOINTS = {
  mobile: 767,
  tablet: 991,
  desktop: 1200,
  largeDesktop: 1440
};

export const ANIMATION = {
  fast: 200,
  normal: 300,
  slow: 500
};

export const Z_INDEX = {
  base: 1,
  overlay: 10,
  modal: 20,
  tooltip: 30,
  header: 100,
  dropdown: 200
};

export const API = {
  base: 'https://racheal-api.onrender.com',
  endpoints: {
    auth: '/auth',
    users: '/users',
    products: '/products',
    leads: '/api/leads'
  }
};

// Full URLs for convenience
export const API_URLS = {
  leads: `${API.base}${API.endpoints.leads}`
};

export const STORAGE_KEYS = {
  theme: 'app_theme',
  token: 'auth_token',
  user: 'user_data'
};

export const LIMITS = {
  maxUploadSize: 10 * 1024 * 1024, // 10MB
  maxTextLength: 500,
  maxRetries: 3
};

export const DEFAULTS = {
  theme: 'light',
  language: 'en',
  currency: 'USD',
  pageSize: 20
};

export type Theme = 'light' | 'dark' | 'system';

export type Language = 'en' | 'es' | 'fr' | 'de' | 'ja';

export type Currency = 'USD' | 'EUR' | 'GBP' | 'JPY' | 'CAD';